import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { MdArrowOutward, MdArrowForward } from 'react-icons/md'
import { projects, hasCaseStudy } from './projectData'

const MotionLink = motion(Link)

// Option C — full-width magazine spreads. Image and copy alternate
// left / right down the page, each revealing on scroll.
export const WorkSpreads = () => {
  return (
    <div className=" space-y-20 md:space-y-32">
      {projects.map((p, i) => {
        const flip = i % 2 === 1
        const study = hasCaseStudy(p)
        // Spreads with a written study open it; the rest link out to the site.
        const Wrapper = study ? MotionLink : motion.a
        const linkProps = study
          ? { to: `/projects/${p.slug}` }
          : { href: p.liveURL, target: '_blank', rel: 'noopener noreferrer' }

        return (
          <Wrapper
            key={p.title}
            {...linkProps}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className=" group grid items-center gap-6 md:grid-cols-12 md:gap-10"
          >
            <div
              className={` overflow-hidden rounded-2xl md:col-span-7 ${
                flip ? 'md:order-2 md:col-start-6' : 'md:order-1'
              }`}
            >
              <div className=" aspect-[4/3] w-full overflow-hidden">
                <img
                  src={p.path}
                  alt={p.title}
                  className=" h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
            </div>

            <div className={` md:col-span-5 ${flip ? 'md:order-1 md:row-start-1' : 'md:order-2'}`}>
              <span className=" font-mono text-xs text-ink/40">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className=" mt-2 font-display text-3xl text-maroon tracking-tight md:text-5xl">
                {p.title}
              </h3>
              <div className=" mt-4 font-mono text-xs uppercase tracking-[0.15em] text-mint-deep">
                {p.stack.join(' / ')} — {p.year}
              </div>
              <p className=" mt-4 max-w-sm text-base leading-relaxed text-ink/60">{p.blurb}</p>
              <div className=" mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-ink/60 transition-colors group-hover:text-mint-deep">
                {study ? 'Read case study' : 'Visit'}
                {study ? (
                  <MdArrowForward className=" text-base transition-transform duration-300 group-hover:translate-x-1" />
                ) : (
                  <MdArrowOutward className=" text-base transition-transform duration-300 group-hover:rotate-45" />
                )}
              </div>
            </div>
          </Wrapper>
        )
      })}
    </div>
  )
}
